import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-bauherr-dashboard-workspace',
  templateUrl: './bauherr-dashboard-workspace.component.html',
  styleUrls: ['./bauherr-dashboard-workspace.component.scss']
})
export class BauherrDashboardWorkspaceComponent {}
